module.exports = __webpack_public_path__ + "Hotels_ico.png?354717cf4d12fab5d5eff97217b25b03";